
import react, { useState, useEffect, useRef,useCallback } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link, Link as RouterLink, NavLink, useNavigate, useParams, useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { Button, Typography } from '@mui/material';
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';
import * as coApplicantActions from "../../actions/coApplicantActions";
import * as leadActions from "../../actions/leadActions";



const CoApplicant = (props) => {
  const { id } = useParams();
  const { leadId, coApplicantId } = useParams();
  const location = useLocation();
  const { actions, addEditCoApplicant, coApplicantData, relationShipData, identifiersData,camLatestStatus ,userRoleType,isExternalUser} = props;
  const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
  const navigate = useNavigate();
  const [allRelations, setAllRelations] = useState([]);
  const [allIdentifiers, setAllIdentifiers] = useState([]);
  const [propLeadId, setPropLeadId] = useState('');
  const [getLeadId, setLeadId] = useState('');
  const [getCoApplicantId, setCoApplicantId] = useState('');
  const [allIncidentReportStatus, setAllIncidentReportStatusData] = useState([]);
  const [getAllCoApplicantData, setAllCoApplicantData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [maritalStatus, setMaritalStatus] = useState('');
  const [relationStatus, setRelationStatus] = useState('');
  const [mobileReadOnly, setMobileReadOnly] = useState(false);

  const [preloaderAadharStatus, setPreloaderAadharStatus] = useState(false);
  const [preloaderAadharOTPVerifyStatus, setPreloaderAadharOTPVerifyStatus] = useState(false);
  const [aadharVerifiedByName, setAadharVerifiedByName] = useState('');
  const [aadharVerifiedDate, setAadharVerifiedDate] = useState('');
  const [leadAadharDetails, setLeadAadharDetails] = useState('');
  const [skipAadharNumberToSave, setSkipAadharNumberToSave] = useState(true);
  const [aadharVerifiedStatus, setAadharVerifiedStatus] = useState(false);
  const [aadharOTPSentStatus, setAadharOTPSentStatus] = useState('0');
  const [aadharRefid, setAadharRefid] = useState("0");
  const [aadharValidationID, setAadharValidationID] = useState('');
  const [referenceId, setReferenceId] = useState('');

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [iframeUrl, setIframeUrl] = useState('');
  const [aadharDigiVerifiedByName, setAadharDigiVerifiedByName] = useState("");
  const [aadharDigiVerifiedDate, setAadharDigiVerifiedDate] = useState("");
  const [aadharDigiAadhaarError, setAadharDigiAadhaarError] = useState([]);
  const [addEditSubmitBtnAction, setAddEditSubmitBtnAction] = useState(true);
  const intervalRef = useRef(null);
  const [selectedId, setSelectedId] = useState(null);
  const [previousTokenVal , setPreviousTokenVal]  = useState('');
  const [phoneDetailsInfoName, setPhoneDetailsInfoName] = useState("");

  const [allLeadActivity, setAllLeadActivity] = useState([]);
  const [preloaderStatus, setPreloaderStatus] = useState(false);
  const [preloaderStatusPhone, setPreloaderStatusPhone] = useState(false);
  const [leadPanDetails, setLeadPanDetails] = useState(""); 
    
  const [panDetailsInfoName, setPanDetailsInfoName] = useState("");
  const [panDetailsInfoDoB, setPanDetailsInfoDoB] = useState("");
  const [panDetailsInfoGender, setPanDetailsInfoGender] = useState("");
  const [panDetailsInfoAddress, setPanDetailsInfoAddress] = useState("");
  const [showTicketListDetails, setShowTicketListDetails] = useState(false);
  const [allTicketData, setAllTicketData] = useState([]);
  const [isPinStyled, setIsPinStyled] = useState(false);
  const [senttoCreditStatus, setSenttoCreditStatus] = useState(false);
  const [enableCamDetailsStatus, setEnableCamDetailsStatus] = useState(false);
  const [vivritiChecklistStatus, setVivritiChecklistStatus] = useState(false);
  const [allDealers, setAllDealers] = useState([]);
  const [isNameStyled, setIsNameStyled] = useState(false);
  const [isDobStyled, setIsDobStyled] = useState(false);
  const [isAddressStyled, setIsAddressStyled] = useState(false);
  const [isCityStyled, setIsCityStyled] = useState(false);
  const [isDistrictStyled, setIsDistrictStyled] = useState(false); 
  const [outputBefiscHtml, setOutputBefiscHtml] = useState("");
  
  const formRef = useRef(null);

  const [formValues, setFormValues] = useState({
    marital_status: '',
    created_by: '',
    status: '',
    mobile: '',
    email: '',
    first_name: '',
    last_name: '',
    gender: '',
    identifier_type: '',
    relation: '',
    pan_number: '',
    adhar_number: '',
    dob: '',
    full_address: '',
    city: '',
    district:'',
    state: '',
    pin: '',
    aadhar_otp:''
  });


   

  useEffect(() => {
    setAllIdentifiers(false);
    const obj = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestData = encryptData(obj);
    const response = actions.identifiersData(requestData, false);
    response.then((result) => {
      // console.log("Promise resolved -  master profile data:", result); 
      if (result.data.success === 1) {
        const results = result.data.data.data;
        const resultArr = Object.keys(results).map((key) => results[key]);
        setAllIdentifiers(resultArr);
      }
    }).catch((error) => {
      //  console.error("Promise rejected -  source data :", error); 
    });
  }, [setAllIdentifiers]);


  const initAadharForm = () => { 
    setAadharVerifiedStatus(false);
    setSkipAadharNumberToSave(true);
    setAadharVerifiedByName('');
    setAadharVerifiedDate('');
    setAadharOTPSentStatus('0');
    setAadharDigiVerifiedByName('');
    setAadharDigiVerifiedDate(''); 
  };

const fetchRecords = useCallback(() => {
       if (id !== undefined) {
      setPropLeadId(atob(id));
      setLeadId(propLeadId);

      const obj = { 'start': '0', 'length': config.MAX_RECORDS, "lead_id": atob(id) };
      // console.log("obj lead id- ", obj);
      const requestData = encryptData(obj);
      const response = actions.coApplicantData(requestData);

      response.then((result) => {
        // console.log("Promise resolved -  source data:", result); 
        if (result.data.success === 1) {
          const results = result.data.data.data;
          const resultArr = Object.keys(results).map((key) => results[key]);
          setAllCoApplicantData(resultArr);
        }
      }).catch((error) => {
        //  console.error("Promise rejected -  source data :", error); 
      });
    }
    }, [setAllCoApplicantData]);

  useEffect(() => {
     fetchRecords();
  }, [fetchRecords]); 

  const onSubmit = (data) => {

    if(camLatestStatus ==='1'){
        toast.error("This lead has been approved by the Credit Head, you cannot modify the details", {
              position: "top-right",
          });
          return;
    }

    if(!addEditSubmitBtnAction){
       toast.error("Crif generated for this user, you cannot modify the details", {
              position: "top-right",
          });
          return;
    }

    const specialCharacterRegex = /[!@#$%^&*()_+|~=`{}[\]:";'<>?,./\\-]/;
    // if (!/^\d{10}$/.test(formValues.mobile)) {
    //   toast.error('Invalid mobile number.', {
    //       position: "top-right",
    //   });
    // } else
    if (specialCharacterRegex.test(formValues.first_name)) {
      toast.error("First name special characters not allowed.", {
        position: "top-right",
      });
    } else if (specialCharacterRegex.test(formValues.last_name)) {
      toast.error("Last name special characters not allowed.", {
        position: "top-right",
      });
    } else if (formValues.full_address.length < 10) {
      toast.error('Address is incomplete, please specify fully.', {
        position: "top-right",
      });
    }else {
      // console.log("Co-Appicant =  ", props);
      const leadId = props.leadId;
      setLeadId(leadId);

      // if(skipAadharNumberToSave){
      if(aadharOTPSentStatus < 2) {  
       // formValues.adhar_number = ''; // 
       // managing in admin // skip the aadhar number to save if it is not verified 
      }

      let params = {
        "lead_id": leadId,
        "first_name": formValues.first_name,
        "last_name": formValues.last_name,
        "mobile": formValues.mobile,
        "email": formValues.email,
        "gender": formValues.gender,
        "marital_status": maritalStatus,
        "identifier_type": formValues.identifier_type,
        "relation": relationStatus,
        "pan_number": formValues.pan_number,
        "adhar_number": formValues.adhar_number,
        "dob": formValues.dob,
        "full_address": formValues.full_address,
        "city": formValues.city,
        "district": formValues.district,
        "state": formValues.state,
        "pin": formValues.pin,
        "aadhar_validation_id" :aadharValidationID ,'aadhar_verified' : aadharOTPSentStatus,
         refid: aadharRefid,
         pan_details: leadPanDetails,
         "referenceId" : referenceId
      };

      if (getCoApplicantId !== '') {
        params = {
          "id": getCoApplicantId,
          "lead_id": leadId,
          "first_name": formValues.first_name,
          "last_name": formValues.last_name,
          "mobile": formValues.mobile,
          "email": formValues.email,
          "gender": formValues.gender,
          "marital_status": formValues.marital_status,
          "identifier_type": formValues.identifier_type,
          "relation": relationStatus,
          "pan_number": formValues.pan_number,
          "adhar_number": formValues.adhar_number,
          "dob": formValues.dob,
          "full_address": formValues.full_address,
          "city": formValues.city,
          "district": formValues.district,
          "state": formValues.state,
          "pin": formValues.pin, 
          "aadhar_validation_id" :aadharValidationID ,'aadhar_verified' : aadharOTPSentStatus,
          refid: aadharRefid,
          pan_details: leadPanDetails,
         "referenceId" : referenceId
        };
      }

      const requestData = encryptData(params);
      const response = actions.addEditCoApplicant(requestData, navigate);

      response.then((result) => {
        // console.log("Promise resolved - add/edit lead form:", result); 
        if (result.data.success === 1) {
          toast.success(result.data.message, {
            position: "top-right",
          });
          const coApplicantId = result.data.id;
          setCoApplicantId("");
          // fetchIncidentReporte();

          setFormValues({
            marital_status: '',
            created_by: '',
            status: '',
            mobile: '',
            email: '',
            first_name: '',
            last_name: '',
            gender: '',
            identifier_type: '',
            relation: '',
            pan_number: '',
            adhar_number: '',
            dob: '',
            full_address: '',
            city: '',
            district:'',
            state: '',
            pin: ''
          });

          reset();
          setRelationStatus("");
          setAllRelations([]);
          initAadharForm();

          setLeadPanDetails("");
          setPanDetailsInfoName("");
          setPanDetailsInfoDoB("");
          setPanDetailsInfoGender("");
          setPanDetailsInfoAddress("");

          setLeadId(propLeadId);
          const obj = { 'start': '0', 'length': config.MAX_RECORDS, "lead_id": propLeadId };
          const requestData = encryptData(obj);
          const response = actions.coApplicantData(requestData);
          response.then((result) => {
            // console.log("Promise resolved -  source data:", result); 
            if (result.data.success === 1) {
              const results = result.data.data.data;
              const resultArr = Object.keys(results).map((key) => results[key]);
              setAllCoApplicantData(resultArr);
              props.updateParentState(false);


              

            }
          }).catch((error) => {
            //  console.error("Promise rejected -  source data :", error); 
          });

        } else {
          toast.error(result.data.message, {
            position: "top-right",
          });
        }
      }).catch((error) => {
        toast.error(error, {
          position: "top-right",
        });
      });
    }
  };




  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormValues({
      ...formValues,
      [name]: value,
    });

  };


  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1); // Reset to the first page when searching
  };

  const filteredItems = getAllCoApplicantData.filter(item => {
    const firstName = item.first_name?.toLowerCase() || '';
    const formattedID = item.formatetdID?.toLowerCase() || '';
    const mobile = item.mobile?.toLowerCase() || '';
    const gender = item.gender?.toLowerCase() || '';
    const relation = item.relation?.toLowerCase() || '';

    return (
      firstName.includes(searchQuery.toLowerCase()) ||
      formattedID.includes(searchQuery.toLowerCase()) ||
      mobile.includes(searchQuery.toLowerCase()) ||
      gender.includes(searchQuery.toLowerCase()) ||
      relation.includes(searchQuery.toLowerCase())
    );
  }
  );

  const startIndex = (currentPage - 1) * config.ITEMS_PER_PAGE;
  const endIndex = startIndex + config.ITEMS_PER_PAGE;
  const paginatedItems = filteredItems.slice(startIndex, endIndex);
  const totalPages = Math.ceil(filteredItems.length / config.ITEMS_PER_PAGE);

  const onRowClickAction = (itemObj, btnAction) => {

    setAddEditSubmitBtnAction(true);
    if (btnAction === 'edit' || btnAction === 'view') {

      if(btnAction === 'view'){
         setAddEditSubmitBtnAction(false);
      }
      

      setMobileReadOnly(false);

      if (formRef.current) {
        formRef.current.scrollIntoView({ behavior: 'smooth' });
      }

      setCoApplicantId(itemObj.id);

      let panNumber = '';
      if (itemObj.pan_number !== '' && itemObj.pan_number !== null) {
          panNumber = itemObj.pan_number.replace(/"/g, '');
      }

      let adharNumber = '';
      if (itemObj.adhar_number !== '' && itemObj.adhar_number !== null) {
          adharNumber = itemObj.adhar_number.replace(/"/g, '');
      }
      const initialFormValues = {
        first_name: itemObj.first_name,
        last_name: itemObj.last_name,
        mobile: itemObj.mobile,
        email: itemObj.email,
        gender: itemObj.gender,
        marital_status: itemObj.marital_status,
        identifier_type: itemObj.identifier_type,
        relation: itemObj.relation,
        pan_number: panNumber,
        adhar_number: adharNumber,
        dob: itemObj.dob,
        full_address: itemObj.full_address,
        city: itemObj.city,
        district: itemObj.district,
        state: itemObj.state,
        pin: itemObj.pin,
      };
      setFormValues(initialFormValues);

      handleMaritleStatus({ target: { value: itemObj.marital_status } }, 'selectedRelation');
      setMaritalStatus(itemObj.marital_status);

      handleChangeRelation({ target: { value: itemObj.relation } }, 'selectedRelation');
      setRelationStatus(itemObj.relation);

      if ((Object.prototype.hasOwnProperty.call(itemObj, 'crif_info') && itemObj.crif_info !== '')) {
        const crifInfo = itemObj.crif_info; 
       
          if ((Object.prototype.hasOwnProperty.call(crifInfo, 'xml_response_url') && crifInfo.xml_response_url !== '' && crifInfo.xml_response_url !== null) ) {    

               setMobileReadOnly(true);
        } else {
              setMobileReadOnly(false);
        }
      }

      if (Object.prototype.hasOwnProperty.call(itemObj, 'aadhar_otp_sent_status') ) { 
        setAadharOTPSentStatus(itemObj.aadhar_otp_sent_status); 
        if(itemObj.aadhar_otp_sent_status ==='2'){
            setAadharVerifiedStatus(true);
            setSkipAadharNumberToSave(false);

            const aadharVerifiedBy = itemObj?.aadhar_verified_by;  
            if(aadharVerifiedBy !==''){
                setAadharVerifiedByName(aadharVerifiedBy);
            } 
            const aadharVerifiedOn = itemObj?.aadhar_verified_on;  
            if(aadharVerifiedOn !==''){
                setAadharVerifiedDate(formatDateForValue(aadharVerifiedOn));
            }

            if (aadharVerifiedBy !== "") {
              setAadharDigiVerifiedByName(aadharVerifiedBy);
            } 
              if (aadharVerifiedOn !== "") {
              setAadharDigiVerifiedDate(formatDateForValue(aadharVerifiedOn));
            }
        }
    }

    let BefiscHtml = "";
    let BefiscStatus = "";
     if (
            Object.prototype.hasOwnProperty.call(
              itemObj,
              "befiscApiRunStatus"
            ) &&
            itemObj?.befiscApiRunStatus
          ) {
            if (
              Object.prototype.hasOwnProperty.call(
                itemObj,
                "mobileage_response"
              )
            ) {
              const mobileageObj = itemObj?.mobileage_response || [];

              if (mobileageObj.length === 0) {
                BefiscHtml += `<span class="text-danger">Phone Number Age not found.</span>`;
              } else if (
                Object.prototype.hasOwnProperty.call(
                  mobileageObj,
                  "result"
                ) &&
                Object.prototype.hasOwnProperty.call(
                  mobileageObj.result,
                  "mobile_age"
                )
              ) {
                BefiscHtml += `<div>Mobile Age : ${mobileageObj.result.mobile_age}</div>`;
                BefiscStatus = "true";
              }
            }

            if (
              Object.prototype.hasOwnProperty.call(
                itemObj,
                "multiple_upi_response"
              )
            ) {
              const upiObj = itemObj?.multiple_upi_response || [];

              if (upiObj.length === 0) {
                BefiscHtml += `<span class="text-danger">UPI Handle not found.</span>`;
              } else {
                if (
                  Object.prototype.hasOwnProperty.call(upiObj, "result") &&
                  Object.prototype.hasOwnProperty.call(
                    upiObj.result,
                    "name"
                  )
                ) {
                  BefiscHtml += `<div>Name : ${upiObj.result.name}</div>`;
                  BefiscStatus = "true";
                }

                if (
                  Object.prototype.hasOwnProperty.call(upiObj, "result") &&
                  Object.prototype.hasOwnProperty.call(
                    upiObj.result,
                    "upi"
                  ) &&
                  Array.isArray(upiObj.result.upi)
                ) {
                  BefiscHtml += `<div>UPIs : ${upiObj.result.upi.join(
                    ", "
                  )}</div>`;
                  BefiscStatus = "true";
                }
              }
            }
          } else {
            BefiscHtml += `<span class="text-danger">UPI Handle and Phone Number API not run.</span><span>Please click the <b>'Get Phone Number Age + UPI Handle'</b> button.</span> `;
          }
          setOutputBefiscHtml(BefiscHtml);
          setPhoneDetailsInfoName(BefiscStatus);

           if (
                Object.prototype.hasOwnProperty.call(
                  itemObj,
                  "pan_details_decrypt"
                ) &&
                Object.prototype.hasOwnProperty.call(
                  itemObj.pan_details_decrypt,
                  "address"
                )
              ) {
                const panDetailsAddress = `${itemObj.pan_details_decrypt.address.buildingName} ${itemObj.pan_details_decrypt.address.city} ${itemObj.pan_details_decrypt.address.country} ${itemObj.pan_details_decrypt.address.streetName} ${itemObj.pan_details_decrypt.address.state} ${itemObj.pan_details_decrypt.address.pinCode}`;

                setPanDetailsInfoName(
                  itemObj.pan_details_decrypt.name
                );
                setPanDetailsInfoDoB(
                  itemObj.pan_details_decrypt.dob
                );
                setPanDetailsInfoGender(
                  itemObj.pan_details_decrypt.gender
                );
                setPanDetailsInfoAddress(panDetailsAddress);

                setLeadPanDetails(itemObj.pan_details_decrypt);
              }

    } else if (btnAction === "delete") {
      const leadId = props.leadId;

      const obj = { "lead_id": leadId, "id": itemObj.id, "basic_info_type": "co_applicant" };
      const requestData = encryptData(obj);
      const response = actions.deleteLeadBasicInfo(requestData);
      response.then((result) => {
        // console.log("Promise resolved - deleteLeadBasicInfo result:", result);
        if (result.data.success === 1) {
          toast.success(result.data.data.message, {
            position: "top-right",
          });
  
          setLeadId(propLeadId);
          const obj = { 'start': '0', 'length': config.MAX_RECORDS, "lead_id": propLeadId };
          const requestData = encryptData(obj);
          const response = actions.coApplicantData(requestData);
          response.then((result) => {
            // console.log("Promise resolved -  source data:", result); 
            if (result.data.success === 1) {
              const results = result.data.data.data;
              const resultArr = Object.keys(results).map((key) => results[key]);
              setAllCoApplicantData(resultArr);
              props.updateParentState(false);

              initAadharForm();
              
  
            }
          }).catch((error) => {
            //  console.error("Promise rejected -  source data :", error); 
          });
  
        } else {
          toast.error(result.data.data.message, {
            position: "top-right",
          });
        }
      }).catch((error) => {
        toast.error(error, {
          position: "top-right",
        });
      });
    }
  }

  const handleNewButton = () => {
    setAddEditSubmitBtnAction(true);
      
    setCoApplicantId("");
    setMaritalStatus("");
    setRelationStatus("");
    setFormValues({
      marital_status: '',
      created_by: '',
      status: '',
      mobile: '',
      email: '',
      first_name: '',
      last_name: '',
      gender: '',
      identifier_type: '',
      relation: '',
      pan_number: '',
      adhar_number: '',
      dob: '',
      full_address: '',
      city: '',
      district:'',
      state: '',
      pin: ''
    });

    reset();
    setMobileReadOnly(false);
    initAadharForm();

    setOutputBefiscHtml('');
    setPhoneDetailsInfoName('');

    setLeadPanDetails("");
    setPanDetailsInfoName("");
    setPanDetailsInfoDoB("");
    setPanDetailsInfoGender("");
    setPanDetailsInfoAddress("");
    
  }

  const handleMaritleStatus = (event, actionName = '') => {
    let selectedMaritleValue = event.target.value;
    setMaritalStatus(selectedMaritleValue);

    if (selectedMaritleValue !== "") {
      setAllRelations(false);

      if(selectedMaritleValue === "Married"){
        selectedMaritleValue = "";
      }

      const obj = { 'start': '0', 'length': config.MAX_RECORDS, 'status': selectedMaritleValue };
      const requestData = encryptData(obj);
      const response = actions.relationShipData(requestData, false);
      response.then((result) => {
        // console.log("Promise resolved -  master profile data:", result); 
        if (result.data.success === 1) {
          const results = result.data.data.data;
          const resultArr = Object.keys(results).map((key) => results[key]);
          setAllRelations(resultArr);
        }
      }).catch((error) => {
        //  console.error("Promise rejected -  source data :", error); 
      });
    } else {
      setAllRelations([]);
    }
  };

  const handleChangeRelation = (event, actionName = '') => {
    const selectedRelationValue = event.target.value;
    setRelationStatus(selectedRelationValue);
  };

  const handleAadharDetails = () => {
    // alert(`leadId = ${leadId}, formValues.aadhar = ${formValues.aadhar}`);
    if(camLatestStatus ==='1'){
      toast.error("This lead has been approved by the Credit Head, you cannot modify the details", {
            position: "top-right",
        });
        return;
  }
    
    if (!formValues.first_name) {
        toast.error('First name cannot be blank.', {
            position: "top-right",
        });
        return;
    }

    if (!formValues.last_name) {
      toast.error('Last name cannot be blank.', {
          position: "top-right",
      });
      return;
  }

    if (!formValues.dob) {
        toast.error('DoB cannot be blank.', {
            position: "top-right",
        });
        return;
    }

    if (!formValues.adhar_number) {
        toast.error('Aadhar cannot be blank.', {
            position: "top-right",
        });
        return;
    }


    const name = `${formValues.first_name || ''} ${formValues.last_name || ''}`.trim();
    
    setPreloaderAadharStatus(true);
    setReferenceId('');
    const params = { 'section_id': getCoApplicantId, 'aadhar_number': formValues.adhar_number, 'name': name, 'dob': formValues.dob, 'action' : 'befisc_sent_otp','section_name' : 'co_applicant' };
    const requestData = encryptData(params);
    const response = actions.aadharValidation(requestData);

    response.then((result) => {
        // console.log("Promise resolved - add/edit lead form:", result);
        setLeadAadharDetails('');
        setAadharVerifiedByName('');
        setAadharOTPSentStatus('0'); 
        
        console.log("aadhar validation response = ", result.data); 
        if (result.data.success === 1) { 
            if (Object.prototype.hasOwnProperty.call(result.data.data, 'aadhar_otp_sent_status') && result.data.data.aadhar_otp_sent_status !=='') {
              //  if(result.data.data.aadhar_otp_sent_status === '1'){
                    setAadharOTPSentStatus(result.data.data.aadhar_otp_sent_status); 
              //  } 

                if(result.data.data.aadhar_otp_sent_status === '2'){
                    // setAadharVerifiedByName('Verified Successfully');

                    const aadharVerifiedBy = result?.data?.data?.aadhar_verified_by;  
                    if(aadharVerifiedBy !==''){
                        setAadharVerifiedByName(aadharVerifiedBy);
                    } 
                    const aadharVerifiedOn = result?.data?.data?.aadhar_verified_on;  
                    if(aadharVerifiedOn !==''){
                        setAadharVerifiedDate(formatDateForValue(aadharVerifiedOn));
                    }

                    if (aadharVerifiedBy !== "") {
                      setAadharDigiVerifiedByName(aadharVerifiedBy);
                    } 
                     if (aadharVerifiedOn !== "") {
                      setAadharDigiVerifiedDate(formatDateForValue(aadharVerifiedOn));
                    }
                } 
            } 

            if (Object.prototype.hasOwnProperty.call(result.data.data, 'aadhar_validation_id') && result.data.data.aadhar_validation_id !=='') {
                setAadharValidationID(result.data.data.aadhar_validation_id); 
               
            } 

            const requestId = result?.data?.data?.sendOTPResponse?.result?.requestId;

            setReferenceId(requestId);

            setPreloaderAadharStatus(false);
                toast.success(result.data.message, {
                    position: "top-right",
                }); 
        } else {
            setPreloaderAadharStatus(false);
            toast.error(result.data.message, {
                position: "top-right",
            });
        }
    }).catch((error) => {
        setPreloaderAadharStatus(false);
        // console.error("Promise rejected - add/edit lead form:", error);
        toast.error(error, {
            position: "top-right",
        });
    });

};

const startInterval = (requestId) => {
    // Clear any previous interval
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    // Start a new interval
    intervalRef.current = setInterval(() => {
      console.log("This runs every 5 seconds =", requestId);
      getAadharTimbleDetailsDigiLocker(requestId);
    }, 5000);
  };

const getAadharDetailsDigiLocker = (requestId='') => {

    if(referenceId === ''){ 
      setReferenceId(requestId);
    }
     
    console.log("Ready to run getAadharDetailsDigiLocker after 5 seconds ", requestId);
    setPreloaderAadharStatus(false);  
    if ( requestId === '') { 
      return;
    } 
    
     const name = `${formValues.first_name || ''} ${formValues.last_name || ''}`.trim();
     const params = {
      section_id: getCoApplicantId,
      aadhar_number: formValues.adhar_number,
      'name': name,
      dob: formValues.dob,
      action: "digi_locker_other_details",
      section_name: "co_applicant",
      'referenceId': requestId,
    };
    const requestData = encryptData(params);
    const response = actions.getAadharDetailsDigiLocker(requestData); 
    setAadharDigiAadhaarError('');
    setAadharRefid('');
    response
      .then((result) => { 
         // console.log("aadhar validation response = ", result.data);
        // alert(result.data.success); 
         const responseData = result?.data?.data; 
        if (result.data.success === 1) {  
          console.log("getAadharDetailsDigiLocker responseData = ",responseData)
          if( responseData?.eaadhaarDocumentInXMLStatus === 'generated'){

           if (responseData?.aadhar_otp_sent_status === "2") {
                 const aadharVerifiedBy = responseData?.aadhar_verified_by;
                if (aadharVerifiedBy !== "") {
                  setAadharDigiVerifiedByName(aadharVerifiedBy);
                } 
                const aadharVerifiedOn =  responseData?.aadhar_verified_on;
                if (aadharVerifiedOn !== "") {
                  setAadharDigiVerifiedDate(formatDateForValue(aadharVerifiedOn));
                }
                setAadharOTPSentStatus(responseData?.aadhar_otp_sent_status);
                setAadharRefid(responseData?.referenceId);
                if (
                    Object.prototype.hasOwnProperty.call(
                      responseData,
                      "aadhar_validation_id"
                    ) &&
                    responseData.aadhar_validation_id !== ""
                  ) {
                    setAadharValidationID(responseData.aadhar_validation_id);
                  }

            }
           // else{
            //   setAadharDigiVerifiedByName("");
           // }
          }
        } else {
          setPreloaderAadharStatus(false); 
           if (responseData?.eaadhaarDocumentInXMLStatus === "generated") { 
              setAadharDigiAadhaarError(result.data.message);
           } 
        }
      })
      .catch((error) => {
        setPreloaderAadharStatus(false);
        
      });
  }

const handleAadharDetailsDigiLocker = () => {
    // alert(`leadId = ${leadId}, formValues.aadhar = ${formValues.aadhar}`);
    setIsModalOpen(false);
    setIframeUrl('');
    if(camLatestStatus ==='1'){
        toast.error("This lead has been approved by the Credit Head, you cannot modify the details", {
              position: "top-right",
          });
          return;
    }
    
     if (!formValues.first_name) {
        toast.error('First name cannot be blank.', {
            position: "top-right",
        });
        return;
    }

    if (!formValues.last_name) {
      toast.error('Last name cannot be blank.', {
          position: "top-right",
      });
      return;
  }

    if (!formValues.dob) {
        toast.error('DoB cannot be blank.', {
            position: "top-right",
        });
        return;
    }

    if (!formValues.adhar_number) {
        toast.error('Aadhar cannot be blank.', {
            position: "top-right",
        });
        return;
    }

    const name = `${formValues.first_name || ''} ${formValues.last_name || ''}`.trim();
    setPreloaderAadharStatus(true);
    setReferenceId("");
    
    const params = {
      section_id: getCoApplicantId,
      aadhar_number: formValues.adhar_number,
      'name': name,
      dob: formValues.dob,
      action: "digi_locker_access_token_generation",
      section_name: "co_applicant",
    };
    const requestData = encryptData(params);
    const response = actions.aadharDigiLockerValidation(requestData);
    
    response
      .then((result) => {
        // console.log("Promise resolved - add/edit lead form:", result);
        setLeadAadharDetails("");
        setAadharVerifiedByName("");
        setAadharOTPSentStatus("0");

         // console.log("aadhar validation response = ", result.data);
        if (result.data.success === 1) { 
          const responseData = result?.data?.data?.responseInfo?.data;

          const requestId = responseData?.data?.refid;
          const authorizationUrl = responseData?.data?.authorization_url;
          const requestMessage = responseData?.message; 
          
         
          setPreloaderAadharStatus(false);
          if (requestMessage) { 
            toast.success(requestMessage, {
              position: "top-right",
            });
          }else{
             toast.error(requestMessage, {
              position: "top-right",
            });
          }

          if(authorizationUrl !== '' && requestId !==''){  
             setReferenceId(requestId);
              setTimeout(() => {
                window.open(authorizationUrl, '_blank');
              }, 1000);

              /* const interval = setInterval(() => {
                console.log("This runs every 5 seconds = ",requestId);
                getAadharDetailsDigiLocker(requestId);
              }, 5000); */
              startInterval(requestId); 
                
          }else{
             toast.error(requestMessage, {
              position: "top-right",
            });
          }
        } else {
          setPreloaderAadharStatus(false);
          toast.error(result.data.message, {
            position: "top-right",
          });
        }
      })
      .catch((error) => {
        setPreloaderAadharStatus(false);
        // console.error("Promise rejected - add/edit lead form:", error);
        toast.error(error, {
          position: "top-right",
        });
      });
  };

  const getAadharTimbleDetailsDigiLocker = (requestId='') => {
  
      if(referenceId === ''){ 
        setReferenceId(requestId);
      }
      
      console.log("Ready to run getAadharDetailsDigiLocker after 5 seconds ", requestId);
      setPreloaderAadharStatus(false);  
      if ( requestId === '') { 
        return;
      } 
      
      const name = `${formValues.first_name || ''} ${formValues.last_name || ''}`.trim();
      const params = {
        section_id: getCoApplicantId,
        aadhar_number: formValues.adhar_number,
        'name': name,
        dob: formValues.dob,
        action: "digi_locker_other_details",
        section_name: "co_applicant",
        'referenceId': requestId,
      };
      const requestData = encryptData(params);
      const response = actions.getAadharTimbleDetailsDigiLocker(requestData); 
      setAadharDigiAadhaarError('');
      setAadharRefid('');
      response
        .then((result) => { 
           // console.log("aadhar validation response = ", result.data);
          // alert(result.data.success); 
           const responseData = result?.data?.data; 
          if (result.data.success === 1) {  
            console.log("getAadharTimbleDetailsDigiLocker responseData = ",responseData)
            if( responseData?.eaadhaarDocumentInXMLStatus === 'generated'){
  
             if (responseData?.aadhar_otp_sent_status === "2") {
                   const aadharVerifiedBy = responseData?.aadhar_verified_by;
                  if (aadharVerifiedBy !== "") {
                    setAadharDigiVerifiedByName(aadharVerifiedBy);
                  } 
                  const aadharVerifiedOn =  responseData?.aadhar_verified_on;
                  if (aadharVerifiedOn !== "") {
                    setAadharDigiVerifiedDate(formatDateForValue(aadharVerifiedOn));
                  }
                  setAadharOTPSentStatus(responseData?.aadhar_otp_sent_status);
                  setAadharRefid(responseData?.referenceId);
                  if (
                      Object.prototype.hasOwnProperty.call(
                        responseData,
                        "aadhar_validation_id"
                      ) &&
                      responseData.aadhar_validation_id !== ""
                    ) {
                      setAadharValidationID(responseData.aadhar_validation_id);
                    }
                     
              }
             // else{
              //   setAadharDigiVerifiedByName("");
             // }
            }
          } else {
            setPreloaderAadharStatus(false); 
             if (responseData?.eaadhaarDocumentInXMLStatus === "generated") { 
                setAadharDigiAadhaarError(result.data.message);
             } 
          }
        })
        .catch((error) => {
          setPreloaderAadharStatus(false);
          
        });
    }
  
    const handleAadharDetailsTimbleDigiLocker = () => {
     // alert(`leadId = ${leadId}, formValues.aadhar = ${formValues.aadhar}`);
    setIsModalOpen(false);
    setIframeUrl('');
    if(camLatestStatus ==='1'){
        toast.error("This lead has been approved by the Credit Head, you cannot modify the details", {
              position: "top-right",
          });
          return;
    }
    
     if (!formValues.first_name) {
        toast.error('First name cannot be blank.', {
            position: "top-right",
        });
        return;
    }

    if (!formValues.last_name) {
      toast.error('Last name cannot be blank.', {
          position: "top-right",
      });
      return;
  }

    if (!formValues.dob) {
        toast.error('DoB cannot be blank.', {
            position: "top-right",
        });
        return;
    }

    if (!formValues.adhar_number) {
        toast.error('Aadhar cannot be blank.', {
            position: "top-right",
        });
        return;
    }

    const name = `${formValues.first_name || ''} ${formValues.last_name || ''}`.trim();
    setPreloaderAadharStatus(true);
    setReferenceId("");
    
    const params = {
      lead_id: propLeadId,
      section_id: getCoApplicantId,
      aadhar_number: formValues.adhar_number,
      'name': name,
      dob: formValues.dob,
      action: "digi_locker_access_token_generation",
      section_name: "co_applicant",
    };
       
      const requestData = encryptData(params);
      const response = actions.aadharTimbleDigiLockerValidation(requestData);
      
      response
        .then((result) => {
          // console.log("Promise resolved - add/edit lead form:", result);
          setLeadAadharDetails("");
          setAadharVerifiedByName("");
          setAadharOTPSentStatus("0");
  
           // console.log("aadhar validation response = ", result.data);
          if (result.data.success === 1) { 
            const responseData = result?.data?.data?.responseInfo?.data;
  
            const requestId = responseData?.x_unique_Id;
            const authorizationUrl = responseData?.UrlforAuth;
            const requestMessage = responseData?.message;
            const previousToken = result?.data?.data?.previous_token; 
            
           
            setPreloaderAadharStatus(false);
            if (requestMessage) { 
              toast.success(requestMessage, {
                position: "top-right",
              });
            }else{
               toast.error(requestMessage, {
                position: "top-right",
              });
            }
  
            if(authorizationUrl !== '' && requestId !==''){  
               setReferenceId(requestId);
               setPreviousTokenVal(previousToken);
                setTimeout(() => { 
               //  const urlNew =  `${authorizationUrl}&forceRefresh=${Date.now()}`;
                 const urlNew =  `${authorizationUrl}`;
                 // alert(urlNew);
                // setIsOpen(true);
                //  setIframeSrc(`${urlNew}`);
                //  setIframeLoaded(true);
                   window.open(urlNew, '_blank');
                }, 500);
   
                /* const interval = setInterval(() => {
                  console.log("This runs every 5 seconds = ",requestId);
                  getAadharDetailsDigiLocker(requestId);
                }, 5000);  */ 
                startInterval(requestId);
                  
            }else{
               toast.error(requestMessage, {
                position: "top-right",
              });
            }
          } else {
            setPreloaderAadharStatus(false);
            toast.error(result.data.message, {
              position: "top-right",
            });
          }
        })
        .catch((error) => {
          setPreloaderAadharStatus(false);
          // console.error("Promise rejected - add/edit lead form:", error);
          toast.error(error, {
            position: "top-right",
          });
        });
    };

const formatDateForValue = (date) => {
    if (!date || Number.isNaN(new Date(date).getTime())) {
        return '';  // Return an empty string for invalid or empty dates
    }

    const newDate = new Date(date);
    const year = newDate.getFullYear();
    const month = String(newDate.getMonth() + 1).padStart(2, '0');
    const day = String(newDate.getDate()).padStart(2, '0');

    return `${day}-${month}-${year}`;
};

const handleAadharOTPVerifyDetails = () => {
  if (!formValues.first_name) {
      toast.error('First name cannot be blank.', {
          position: "top-right",
      });
      return;
  }

  if (!formValues.last_name) {
    toast.error('Last name cannot be blank.', {
        position: "top-right",
    });
    return;
  }

  if (!formValues.dob) {
      toast.error('DoB cannot be blank.', {
          position: "top-right",
      });
      return;
  }

  if (!formValues.adhar_number) {
      toast.error('Aadhar cannot be blank.', {
          position: "top-right",
      });
      return;
  }


  const name = `${formValues.first_name || ''} ${formValues.last_name || ''}`.trim();

    // alert(`leadId = ${leadId}, formValues.aadhar = ${formValues.aadhar}`);
    setPreloaderAadharOTPVerifyStatus(true);
    const params = { 'section_id': getCoApplicantId, 'aadhar_number': formValues.adhar_number, 'name': name, 'dob': formValues.dob, 'otp': formValues.aadhar_otp,'referenceId':referenceId, 'action' : 'download_aadhar','section_name' : 'co_applicant'};
    const requestData = encryptData(params);
    const response = actions.aadharValidation(requestData);

    response.then((result) => {
        // console.log("Promise resolved - add/edit lead form:", result);
        setLeadAadharDetails('');
        setAadharVerifiedByName('');
        if (result.data.success === 1) {
            
            if (Object.prototype.hasOwnProperty.call(result.data.data, 'aadhar_otp_sent_status') && result.data.data.aadhar_otp_sent_status !=='') {
             
            setAadharOTPSentStatus(result.data.data.aadhar_otp_sent_status); 
            if(result.data.data.aadhar_otp_sent_status === '2'){

                
                const aadharVerifiedBy = result?.data?.data?.aadhar_verified_by;  
                if(aadharVerifiedBy !==''){
                    setAadharVerifiedByName(aadharVerifiedBy);
                } 
                const aadharVerifiedOn = result?.data?.data?.aadhar_verified_on;  
                if(aadharVerifiedOn !==''){
                    setAadharVerifiedDate(formatDateForValue(aadharVerifiedOn));
                }
                
                if (aadharVerifiedBy !== "") {
                  setAadharDigiVerifiedByName(aadharVerifiedBy);
                } 
                  if (aadharVerifiedOn !== "") {
                  setAadharDigiVerifiedDate(formatDateForValue(aadharVerifiedOn));
                }
                setAadharVerifiedStatus(true);
                setSkipAadharNumberToSave(false);
            } 
        } 

        

        if (Object.prototype.hasOwnProperty.call(result.data.data, 'aadhar_validation_id') && result.data.data.aadhar_validation_id !=='') {
            setAadharValidationID(result.data.data.aadhar_validation_id); 
            
      } 
      setPreloaderAadharOTPVerifyStatus(false);
            toast.success(result.data.message, {
                position: "top-right",
            }); 


        } else {
            setPreloaderAadharOTPVerifyStatus(false);
            toast.error(result.data.message, {
                position: "top-right",
            });
        }
    }).catch((error) => {
        setPreloaderAadharOTPVerifyStatus(false);
        // console.error("Promise rejected - add/edit lead form:", error);
        toast.error(error, {
            position: "top-right",
        });
    });

}; 
     
 const handleSelect = async (event,id, action) => {


      if(id === '' || id === undefined){
         toast.error("Row is not selected.", {
              position: "top-right",
          });
          return;
      }

      const actionStatus = (event.target.checked) ? 1 : 0;
      
      const obj = { 'start': '0', 'length': config.MAX_RECORDS, "lead_id": propLeadId , 'selected_row_id' : id,'brief' : 'co_applicant', "action" : action, "actionStatus" : actionStatus};
      // console.log("obj lead id- ", obj);
      const requestData = encryptData(obj);
      const response = actions.makeDefaultLeadRecord(requestData);
      response.then((result) => {
        if (result.data.success === 1) {
           toast.success(result.data.data.message, {
              position: "top-right",
            });
            fetchRecords();
        }else{
            toast.error(result.data.data.message, {
              position: "top-right",
            });
        }
      }).catch((error) => {
       toast.error(error, {
          position: "top-right",
        });
      });
  };

  const removeHighlightedFields = () => {
     setIsNameStyled(false);
     setIsDobStyled(false);
     setIsAddressStyled(false);
     setIsCityStyled(false);
     setIsDistrictStyled(false);
     setIsPinStyled(false);
  };

   const handlePanDetails = () => {
      // alert(`leadId = ${leadId}, formValues.pan = ${formValues.pan}`);
      if(camLatestStatus ==='1'){
          toast.error("This lead has been approved by the Credit Head, you cannot modify the details", {
                position: "top-right",
            });
            return;
      } 
      setPreloaderStatus(true);
      const params = { lead_id: leadId, pan_number: formValues.pan_number , 'api_calling_module' : "coApplicant","id": getCoApplicantId};
      const requestData = encryptData(params);
      const response = actions.updateLeadKarzaPanDetails(requestData);
  
      response
        .then((result) => {
          // console.log("Promise resolved - add/edit lead form:", result);
          setLeadPanDetails("");
          setPanDetailsInfoName("");
          setPanDetailsInfoDoB("");
          setPanDetailsInfoGender("");
          setPanDetailsInfoAddress("");
          if (result.data.success === 1) {
            // console.log("karza pan response = ", result.data.data);
            if (result.data.data.data.statusCode === 101) {
              setPreloaderStatus(false);
              toast.success(result.data.message, {
                position: "top-right",
              });
  
              // alert('karza = 1');
              if (
                Object.prototype.hasOwnProperty.call(
                  result.data.data.data.result,
                  "address"
                )
              ) {
                const panDetailsAddress = `${result.data.data.data.result.address.buildingName} ${result.data.data.data.result.address.city} ${result.data.data.data.result.address.country} ${result.data.data.data.result.address.streetName} ${result.data.data.data.result.address.state} ${result.data.data.data.result.address.pinCode}`;
  
                setPanDetailsInfoName(result.data.data.data.result.name);
                setPanDetailsInfoDoB(result.data.data.data.result.dob);
                setPanDetailsInfoGender(result.data.data.data.result.gender);
                setPanDetailsInfoAddress(panDetailsAddress); 
                removeHighlightedFields();
               // if(result.data.data.data.result.name !==''){

               const fullName = result?.data?.data?.data?.result?.name || "";
               const parts = fullName.trim().split(" ");
               let fName = '';
               let lName = '';
                if (parts.length > 1) {
                   fName = parts[0];
                   lName = parts.slice(1).join(" ");
                } else {
                   fName = parts[0];
                   lName = parts[0];
                }
  
                  setFormValues({
                    ...formValues,
                    first_name: fName,
                    last_name: lName,
                    dob: result.data.data.data.result.dob, 
                    full_address :panDetailsAddress,
                    city: result.data.data.data.result.address.city,
                    pin: result.data.data.data.result.address.pinCode,
                    state: result.data.data.data.result.address.state 
                  });  
  
                  if(result.data.data.data.result.name !==''){
                    setIsNameStyled(true);
                  }
                  if(result.data.data.data.result.name !==''){
                    setIsDobStyled(true);
                  }
  
                  if(panDetailsAddress.trim() !==''){
                    setIsAddressStyled(true);
                  }
  
                  if(result.data.data.data.result.address.city !==''){
                    setIsCityStyled(true);
                  }
  
                  if(result.data.data.data.result?.address?.locality !==''){
                    // setIsDistrictStyled(true);
                  }
                  if(result.data.data.data.result.address.pinCode !==''){
                    setIsPinStyled(true);
                  } 
               // }
                
  
                setLeadPanDetails(result.data.data.data);
              }
            } else if (
              Object.prototype.hasOwnProperty.call(
                result.data.data.data,
                "statusMessage"
              )
            ) {
              setPreloaderStatus(false);
              toast.error(result.data.data.data.statusMessage, {
                position: "top-right",
              });
            } else {
              setPreloaderStatus(false);
              toast.error("No response from api", {
                position: "top-right",
              });
            }
          } else {
            setPreloaderStatus(false);
            toast.error(result.data.message, {
              position: "top-right",
            });
          }
        })
        .catch((error) => {
          setPreloaderStatus(false);
          // console.error("Promise rejected - add/edit lead form:", error);
          toast.error(error, {
            position: "top-right",
          });
        });
    };
  
    const handlePhoneDetails = () => {
      if(camLatestStatus ==='1'){
                toast.error("This lead has been approved by the Credit Head, you cannot modify the details", {
                      position: "top-right",
                  });
                  return;
            }
      setPreloaderStatusPhone(true);
      const params = { lead_id: leadId, phone_number: formValues.mobile, 'api_calling_module' : "coApplicant"};
      const requestData = encryptData(params);
      const response = actions.validateBefiscPhoneDetails(requestData);
  
      response
        .then((result) => {
          // console.log("Promise resolved - add/edit lead form:", result);
          setLeadPanDetails("");
  
          if (result.data.success === 1) {
             // console.log("Befisc phone response = ", result.data.data);
            setPreloaderStatusPhone(false);
            toast.success(result.data.message, {
              position: "top-right",
            });
  
            let BefiscHtml = "";
            let BefiscStatus = "";
  
            if (
              Object.prototype.hasOwnProperty.call(
                result.data.data,
                "befiscApiRunStatus"
              ) &&
              result.data.data.befiscApiRunStatus
            ) {
              if (
                Object.prototype.hasOwnProperty.call(
                  result.data.data,
                  "mobileage_response"
                )
              ) {
                const mobileageObj = result.data.data.mobileage_response;
  
                if (mobileageObj.length === 0) {
                  BefiscHtml += `<span class="text-danger">Phone Number Age not found.</span>`;
                } else if (
                  Object.prototype.hasOwnProperty.call(mobileageObj, "result") &&
                  Object.prototype.hasOwnProperty.call(
                    mobileageObj.result,
                    "mobile_age"
                  )
                ) {
                  BefiscHtml += `<div>Mobile Age : ${mobileageObj.result.mobile_age}</div>`;
                  BefiscStatus = "true";
                }
              }
  
              if (
                Object.prototype.hasOwnProperty.call(
                  result.data.data,
                  "multiple_upi_response"
                )
              ) {
                const upiObj = result.data.data.multiple_upi_response;
  
                if (upiObj.length === 0) {
                  BefiscHtml += `<span class="text-danger">UPI Handle not found.</span>`;
                } else {
                  if (
                    Object.prototype.hasOwnProperty.call(upiObj, "result") &&
                    Object.prototype.hasOwnProperty.call(upiObj.result, "name")
                  ) {
                    BefiscHtml += `<div>Name : ${upiObj.result.name}</div>`;
                    BefiscStatus = "true";
                  }
  
                  if (
                    Object.prototype.hasOwnProperty.call(upiObj, "result") &&
                    Object.prototype.hasOwnProperty.call(upiObj.result, "upi") &&
                    Array.isArray(upiObj.result.upi)
                  ) {
                    BefiscHtml += `<div>UPIs : ${upiObj.result.upi.join(
                      ", "
                    )}</div>`;
                    BefiscStatus = "true";
                  }
                }
              }
            } else {
              BefiscHtml += `<span class="text-danger">UPI Handle and Phone Number API not run.</span><span>Please click the <b>'Get Phone Number Age + UPI Handle'</b> button.</span> `;
            }
  
            setOutputBefiscHtml(BefiscHtml);
            setPhoneDetailsInfoName(BefiscStatus);
          } else {
            setPreloaderStatusPhone(false);
            toast.error(result.data.message, {
              position: "top-right",
            });
          }
        })
        .catch((error) => {
          setPreloaderStatusPhone(false);
          // console.error("Promise rejected - add/edit lead form:", error);
          toast.error(error, {
            position: "top-right",
          });
        });
    };

  return (
    <>
      <h5 className="fw-bold">Co-Applicant</h5>
      <div id="main-wrap" className='mt-4'>
        <div className='row justify-content-between'>
          <div className='col-md-8'>
            <Typography className='line-initial' variant="h4" sx={{ mb: 0 }}>
              List of Co-Applicant
            </Typography>
          </div>
          <div className='col-md-4 pe-0 ps-lg-5'>
            <div className="form-group">
                <label htmlFor="search">
                  {/* Search: */}
                  <input readOnly={props.leadStatusFlag === true}
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                    id="search"
                    value={searchQuery}
                    onChange={handleSearchChange}
                  />
                </label>
            </div>
          </div>
        </div>
        <div className="table-wrap">
          <table className="table table-hover">
            <thead>
              <tr>
                {/* <th>ID</th> */}
                <th>UID</th>
                <th>Name</th>
                <th>Mobile Number</th>
                <th>Gender</th>
                <th>Relation</th>

               { /* {!props.showActionLeadInfo && ( */ }
                  <th>Action</th>
              { /*   )} */ }
               <th>Status</th>
                
              </tr>
            </thead>
            {paginatedItems.length === 0 ? (
              <tbody>
                <tr>
                  <td colSpan="5" style={{ textAlign: 'center' }}>
                    <h5>No Co-Applicant</h5>
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody>
                {paginatedItems.map((item, index) => (
                  <tr key={index}>
                    {/* <td>{item.formatetdID}</td> */}
                    <td>{item.uid}</td>
                    <td>{item.first_name}</td>
                    <td>{item.mobile}</td>
                    <td>{item.gender}</td>
                    <td>{item.relationName}</td>
                  { /*  {!props.showActionLeadInfo && ( */ }
                      <td> 
                        <div className="btn-group dropstart">
                            <button type="button" className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                <i className="bi bi-three-dots-vertical">&nbsp;</i>
                            </button>
                            <ul className="dropdown-menu">

                             {(() => {
                                let editButtonEnabled = true;  
                                if ((Object.prototype.hasOwnProperty.call(item, 'crif_info') && item.crif_info !== '')) {
                                  const crifInfo = item.crif_info; 
                                
                                    if ((Object.prototype.hasOwnProperty.call(crifInfo, 'xml_response_url') && crifInfo.xml_response_url !== '' && crifInfo.xml_response_url !== null) ) {    

                                        editButtonEnabled = false;  
                                  }  
                                } 
                                
                                if(camLatestStatus ==='1'){
                                    editButtonEnabled = false;  
                                }
                              return (
                                <>
                                <li>
                                  <RouterLink onClick={() => onRowClickAction(item, `${(editButtonEnabled) ? 'edit': 'view'}`)} ><i className="bi bi-pen">&nbsp;</i>{(editButtonEnabled) ? 'Edit': 'View'}</RouterLink>
                                </li>

                                 { (editButtonEnabled) && (
                                <li>
                                    <RouterLink onClick={() => onRowClickAction(item, 'delete')} ><i className="bi bi-trash">&nbsp;</i>Delete</RouterLink>
                                </li>
                                )}
                                </>
                               );
                             })()}

                               
                            </ul>
                        </div>

                      {(userRoleType === "Credit" || userRoleType === "Manager" || userRoleType === 'Superadmin' || userRoleType === 'Credit Head' || userRoleType === 'Credit Operations') && (       
                        <div className="float-right">      
                          Make Default <br/>         
                          <input
                            type="radio"
                            name="options"
                            checked={selectedId === item.id || item.vivriti_default === '1' }
                            onChange={(event) => handleSelect(event,item.id,'vivriti_default')}
                          />
                        </div>
                      )}

                      </td>
                  { /*  )} */}

                    <td>
                        <div className="float-right">      
                            Active <br/>         
                            <input
                              type="checkbox"
                              name="options"
                              checked={selectedId === item.id || item.status === '1' }
                              onChange={(event) => handleSelect(event,item.id,'status')}
                          />
                        </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            )}
          </table>
        </div>

        <div>
          <nav className='mb-1'>
            <ul className="pagination pagination-md justify-content-end">
              {Array.from({ length: totalPages }, (_, index) => index + 1).map(page => (
                <li className="page-item">
                  <button
                    key={page}
                    onClick={() => handlePageChange(page)}
                    disabled={currentPage === page}
                    className="page-link"
                  >
                    {page}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>

      <div id="main-wrap" className='mt-4'>
        <div className='row justify-content-between'>

          <div className="row">
            <div className='col-md-9'>
              <h5> {getCoApplicantId === '' ? 'Add' : ((!addEditSubmitBtnAction) ? "View" : "Edit")} Co-Applicant</h5>
            </div>
            {getCoApplicantId !== '' && (
              <div className='col-md-3'>
                <div className='form-group text-end mb-2'>
                  <button className="btn btn-primary" onClick={() => handleNewButton()}>Add New</button>
                </div>
              </div>
            )}
          </div>
          
          <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data" ref={formRef}>
            <div className="row co-applicant" id="co-applicant-1">
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="marital_status">
                    <span>Marital Status <a style={{ color: "red" }}>*</a></span>
                    <select disabled={props.leadStatusFlag === true} id="marital_status" name="marital_status" className="form-select"  {...register('marital_status')} 
                      value={maritalStatus}
                      onChange={handleMaritleStatus}>
                      <option value="">Please Select</option>
                      <option value="Married">Married</option>
                      <option value="Unmarried">Unmarried</option>
                    </select>
                  </label>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="relation">
                    <span>Relationship <a style={{ color: "red" }}>*</a></span>
                    <select disabled={props.leadStatusFlag === true} id="relation" name="relation" className="form-select" {...register('relation')}
                      value={relationStatus}
                      onChange={handleChangeRelation}>
                      <option value="">Please Select</option>
                      {allRelations.length > 0 && allRelations.map((option) => (
                        <option value={option.id}>
                          {option.relation_name}
                        </option>
                      ))}
                    </select>
                  </label>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="first_name">
                    <span>First Name <a style={{ color: "red" }}>*</a></span>
                    <input readOnly={props.leadStatusFlag === true} type="text" id="first_name" name="first_name" className="form-control"
                      {...register('first_name')}
                      value={formValues.first_name}
                      onChange={handleChange}
                    />
                  </label>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="last_name">
                    <span>Last Name <a style={{ color: "red" }}>*</a></span>
                    <input readOnly={props.leadStatusFlag === true} type="text" id="last_name" name="last_name" className="form-control" {...register('last_name')}
                      value={formValues.last_name}
                      onChange={handleChange} placeholder="" />
                  </label>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="dob">
                    <span>Date Of Birth <a style={{ color: "red" }}>*</a></span>
                    <input readOnly={props.leadStatusFlag === true} type="date" id="dob" name="dob" className="form-control"
                      {...register('dob')}
                      value={formValues.dob}
                      onChange={handleChange}
                    />
                  </label>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="mobile">
                    <span>Mobile Number <a style={{ color: "red" }}>*</a></span>
                    <input readOnly={props.leadStatusFlag === true || mobileReadOnly === true} type="tel" id="mobile" name="mobile" className="form-control" {...register('mobile')}
                      value={formValues.mobile}
                      onChange={handleChange}
                      />

                       {!isExternalUser && (
                        <>
                          {phoneDetailsInfoName === "" ? (
                            <>
                              <button
                                type="button"
                                className="btn btn-success float-right validate-phone"
                                onClick={() =>
                                  handlePhoneDetails()
                                }
                              >
                                {preloaderStatusPhone && (
                                  <>
                                    <div
                                      className="spinner-border small-preloader"
                                      role="status"
                                    >
                                      <span className="visually-hidden">
                                        {" "}
                                        Loading...
                                      </span>
                                    </div>
                                  </>
                                )}
                                Get Phone Number Age + UPI Handle
                              </button>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      )}
                  </label>
                </div>
                 {!isExternalUser && (
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: outputBefiscHtml.replace(
                          /\n/g,
                          "<br />"
                        ),
                      }}
                    />
                  </>
                )}
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="email">
                    <span>Email Address</span>
                    <input readOnly={props.leadStatusFlag === true} type="email" id="email" name="email" className="form-control" {...register('email')}
                      value={formValues.email}
                      onChange={handleChange} />
                  </label>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="gender">
                    <span>Gender</span>
                    <select disabled={props.leadStatusFlag === true} id="gender" name="gender" className="form-select" {...register('gender')}
                      value={formValues.gender}
                      onChange={handleChange}>
                      <option value="">Please select</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                  </label>
                </div>
              </div>
              <div className="col-md-6 d-none">
                <div className="form-group">
                  <label htmlFor="identifier_type">
                    <span>Identifier Type</span>
                    <select disabled={props.leadStatusFlag === true} id="identifier_type" name="identifier_type" className="form-select" {...register('identifier_type')}
                      value={formValues.identifier_type}
                      onChange={handleChange}>
                      <option value="">Select</option>
                      {allIdentifiers.length > 0 && allIdentifiers.map((option) => (
                        <option value={option.id}>
                          {option.identifier_name}
                        </option>
                      ))}
                    </select>
                  </label>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="pan_number">
                    <span>Pan Number </span>
                    <input readOnly={props.leadStatusFlag === true} type="text" id="pan_number" name="pan_number" className="form-control"
                      {...register('pan_number')}
                      value={formValues.pan_number}
                      onChange={handleChange}
                    />
                  </label>
                </div>

                 {panDetailsInfoName === "" ||
                    !isExternalUser ? (
                      <>
                        <button
                          type="button"
                          className="btn btn-success float-right pan_fetch"
                          onClick={() => handlePanDetails()}
                        >
                          {preloaderStatus && (
                            <>
                              <div
                                className="spinner-border small-preloader"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  {" "}
                                  Loading...
                                </span>
                              </div>
                            </>
                          )}
                          PAN Profile Details
                        </button>
                      </>
                    ) : (
                      <></>
                    )}
                    <div className="f-14px rounded overflow-hidden">
                      {panDetailsInfoName !== "" ? (
                        <div className="py-1 px-2 bg-light">
                          {" "}
                          <b>Name : </b> {panDetailsInfoName}
                        </div>
                      ) : (
                        <></>
                      )}
                      {panDetailsInfoDoB !== "" ? (
                        <div className="pb-1 px-2 bg-light">
                          {" "}
                          <b>DoB : </b> {panDetailsInfoDoB}
                        </div>
                      ) : (
                        <></>
                      )}
                      {panDetailsInfoGender !== "" ? (
                        <div className="pb-1 px-2 bg-light">
                          {" "}
                          <b>Gender : </b> {panDetailsInfoGender}
                        </div>
                      ) : (
                        <></>
                      )}
                      {panDetailsInfoAddress !== "" ? (
                        <div className="pb-1 px-2 bg-light">
                          {" "}
                          <b>Address : </b> {panDetailsInfoAddress}
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>

              </div>

              { /* Aadhar  validation :start here */ }
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="adhar_number">
                    <span>Aadhaar Number <a style={{ color: "red" }}>* </a></span>
                    <input readOnly={props.leadStatusFlag === true} type="text" id="adhar_number" name="adhar_number" className="form-control"
                      {...register('adhar_number')}
                      value={formValues.adhar_number}
                      onChange={handleChange}
                      // disabled={getCoApplicantId !== '' && formValues.adhar_number !== ""}
                    />
                  </label>
                </div>

  {
        aadharVerifiedByName === ''  ? (
            <>
                <button
                    type="button"
                    className="btn btn-success float-right pan_fetch d-none"
                    onClick={() => handleAadharDetails()
                    }
                >
                    {preloaderAadharStatus && (<>
                        <div className="spinner-border small-preloader" role="status" >
                            <span className="visually-hidden" > Loading...</span>
                        </div>
                    </ >)}

                    Aadhar Validation {}
                </button>
            </>) : (<></ >)}
    <div className='f-14px rounded overflow-hidden' >
        {aadharVerifiedByName !== '' ? (<div className="py-1 px-2 bg-light d-none" > <b>Verified By : </b>  {aadharVerifiedByName}</div >) : (<></>)}
        {aadharVerifiedDate !== '' ? (<div className="py-1 px-2 bg-light d-none" > <b>Verified On : </b>  {aadharVerifiedDate}</div >) : (<></>)}
        
    </div> 




    {aadharDigiVerifiedByName === "" ? (
      <> 
          <button
          type="button"
          className="btn btn-warning float-right pan_fetch"
          onClick={() => handleAadharDetailsTimbleDigiLocker()}
        >
          {preloaderAadharStatus && (
            <>
              <div
                className="spinner-border small-preloader"
                role="status"
              >
                <span className="visually-hidden">
                  {" "}
                  Loading...
                </span>
              </div>
            </>
          )}
          Aadhar Validation
        </button>
      </>
    ) : (
      <></>
    )}
    <div className="f-14px rounded overflow-hidden">
      {aadharDigiVerifiedByName !== "" ? (
        <div className="py-1 px-2 bg-light">
          {" "}
          <b>Verified By : </b>{" "}
          {aadharDigiVerifiedByName}
        </div>
      ) : (
        <></>
      )}
      {aadharDigiVerifiedDate !== "" ? (
        <div className="py-1 px-2 bg-light">
          {" "}
          <b>Verified On : </b> {aadharDigiVerifiedDate}
        </div>
      ) : (
        <></>
      )}

      {aadharDigiAadhaarError !== "" && (
        <div className="py-1 px-2 text-danger"> 
          {aadharDigiAadhaarError} 
        </div>
      )}
    </div>                  
    { /* Aadhar  validation :end here */ } 


    { !aadharVerifiedStatus  && aadharOTPSentStatus > 0 && (
        <>
        <div className='form-group d-none' >
            <label htmlFor="aadhar_otp" >
                <span>Enter OTP to Verify Aadhar </span>
                < input
                    type='tel'
                    id='aadhar_otp'
                    name='aadhar_otp'
                    className='form-control'
                    {...register('aadhar_otp')}
                    value={formValues.aadhar_otp}
                    onChange={handleChange}
                />
            </label>
        </div>
        
        <button
            type="button"
            className="btn btn-warning float-right pan_fetch d-none"
            onClick={() => handleAadharOTPVerifyDetails()
            }
        > 
        {preloaderAadharOTPVerifyStatus && (<>
            <div className="spinner-border small-preloader" role="status" >
                <span className="visually-hidden" > Loading...</span>
            </div>
        </ >)} 
            Verify
        </button>
             
        </>
        )}


              </div>
              { /* Aadhar  validation :end here */ }


              <div className='col-md-6'>
                <div className='form-group'>
                  <label htmlFor="full_address">
                    <span>Address <a style={{ color: "red" }}>* </a></span>
                    <input readOnly={props.leadStatusFlag === true}
                      type='text'
                      id='full_address'
                      name='full_address'
                      className='form-control'
                      {...register('full_address')}
                      value={formValues.full_address}
                      onChange={handleChange}
                    />
                  </label>
                </div>
              </div>

              <div className='col-md-6'>
                <div className='form-group'>
                  <label htmlFor="city">
                    <span>City</span>
                    <input readOnly={props.leadStatusFlag === true}
                      type='text'
                      id='city'
                      name='city'
                      className='form-control'
                      {...register('city')}
                      value={formValues.city}
                      onChange={handleChange}
                    />
                  </label>
                </div>
              </div>

              <div className='col-md-6'>
                <div className='form-group'>
                  <label htmlFor="district">
                    <span>District <a style={{ color: "red" }}>* </a></span>
                    <input readOnly={props.leadStatusFlag === true}
                      type='text'
                      id='district'
                      name='district'
                      className='form-control'
                      {...register('district')}
                      value={formValues.district}
                      onChange={handleChange}
                    />
                  </label>
                </div>
              </div>

              <div className="col-md-6" >
                <div className='form-group'>
                  <label htmlFor="lead-profile">
                    <span>State</span>
                    <select disabled={props.leadStatusFlag === true}
                      id='state'
                      name='state'
                      className="form-select"
                      {...register('state')}
                      value={formValues.state}
                      onChange={handleChange}
                    >
                      <option value=''>Select State</option>
                      {props.allStates.length > 0 && props.allStates.map((option) => (
                        <option value={option.state_code}>
                          {option.state_name}
                        </option>
                      ))}
                    </select>
                  </label>
                </div>
              </div>


              <div className='col-md-6'>
                <div className='form-group'>
                  <label htmlFor="pin">
                    <span>Pin</span>
                    <input readOnly={props.leadStatusFlag === true}
                      type='text'
                      id='pin'
                      name='pin'
                      className='form-control'
                      {...register('pin')}
                      value={formValues.pin}
                      onChange={handleChange}
                    />
                  </label>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group mb-0">
                  <button disabled={props.leadStatusFlag === true} className="btn btn-primary">Submit</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>


    </>
  );
}

function mapStateToProps(state) {
  return {
    addEditCoApplicant: state.addEditCoApplicant,
    coApplicantData: state.coApplicantData,
    relationShipData: state.relationShipData,
    identifiersData: state.identifiersData,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign(coApplicantActions.default, leadActions.default), dispatch),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(CoApplicant);
